export default __webpack_public_path__ + "static/media/gym-img-08.8dc24e2a.jpg";